// removed by extract-text-webpack-plugin
module.exports = {"root":"_365Hwu1","root_isFirstJobClassic":"_1CYCcVn","root_isLastJobClassic":"_14yeqbb"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultList/SearchResultList.less
 ** module id = 796
 ** module chunks = 0
 **/